module.exports = "/assets/cb10cea80e2472321f56cbfa48d3d4e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/3M.png
// module id = 2144
// module chunks = 0